module.exports = __webpack_public_path__ + "static/Bodoni-72-Bold-6c86005d07a425ad1955f4bcf15b094d.woff";